import { FilterListOutlined } from "@mui/icons-material";
import { Button, Tooltip, type ButtonProps } from "@mui/material";

interface IFilterButtonProps extends ButtonProps {
  tooltip?: string;
}

export const FilterButton = (props: IFilterButtonProps) => {
  return (
    <Tooltip title={props.tooltip ?? ""}>
      <Button
        id="filter-button"
        variant={"text"}
        startIcon={<FilterListOutlined />}
        aria-label="apply-filter"
        sx={(theme) => ({
          px: 3,
          "&:hover": {
            background: theme.palette.grey[200],
          },
        })}
        {...props}
      >
        Filter
      </Button>
    </Tooltip>
  );
};
